import LiveboardClasses from './liveboard_classes';
import TypeReflect from 'models/lib/type_reflect';

export const typeReflect = new TypeReflect(LiveboardClasses);

export default function(liveboard) {
  let LiveboardClass = typeReflect.typeToConstructor(liveboard.type);
  return LiveboardClass.fromJs(liveboard);
}
